import { render } from "./FilesInput.vue?vue&type=template&id=c84f1fe2&scoped=true&ts=true"
import script from "./FilesInput.vue?vue&type=script&lang=ts"
export * from "./FilesInput.vue?vue&type=script&lang=ts"

import "./FilesInput.vue?vue&type=style&index=0&id=c84f1fe2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84f1fe2"]])

export default __exports__